import translations from './translations'

translations.add('pt', {
    allPaymentsSecure: 'Todos os pagamentos são assegurados por',
    poweredBy: 'Distribuído por'
})
